import { api } from "./api";
import type {
  DocumentVersion,
  DocumentHistoryItem,
  DocumentType,
  GenerateResponse,
} from "../types";

export const documentsService = {
  generate: (jobId: string, docType?: DocumentType) =>
    api.post<GenerateResponse>(`/api/jobs/${jobId}/generate`, docType ? { doc_type: docType } : {}),

  getLatest: (jobId: string, docType: DocumentType) =>
    api.get<DocumentVersion>(`/api/jobs/${jobId}/documents/${docType}`),

  save: (jobId: string, docType: DocumentType, content: string) =>
    api.put<DocumentVersion>(`/api/jobs/${jobId}/documents/${docType}`, { content }),

  getHistory: (jobId: string, docType: DocumentType) =>
    api.get<DocumentHistoryItem[]>(`/api/jobs/${jobId}/documents/${docType}/history`),

  restore: (jobId: string, docType: DocumentType, versionId: string) =>
    api.post<DocumentVersion>(
      `/api/jobs/${jobId}/documents/${docType}/restore/${versionId}`
    ),

  chat: (jobId: string, docType: DocumentType, instruction: string) =>
    api.post<DocumentVersion>(`/api/jobs/${jobId}/documents/${docType}/chat`, {
      instruction,
    }),

  exportPdfUrl: (jobId: string, docType: DocumentType) =>
    `/api/jobs/${jobId}/documents/${docType}/export/pdf`,
};
